import {
  QuerySearchUserResourcesArgs,
  SearchableResourceAggsInput,
} from "@examspark/types";
import {
  ArraySearchFields,
  SearchFields,
} from "@examspark/types/dist/components/activity-editor";

export const defaultSearchState: SearchState = {
  variables: {},
  filter: {},
  dataChanged: 0,
  resultsChanged: 0,
};

export const searchReducer = (state: SearchState, action: SearchAction) => {
  state = { ...state };

  switch (action.type) {
    case "INITIAL":
      console.log("initial");
      state.variables = action.data;
      return state;
    case "RESET":
      state.filter = {};
      state.nextToken = undefined;
      state.dataChanged = Date.now();
      return state;
    case "UPDATE":
      if (!state.filter) state.filter = {};
      state.filter = Object.assign({}, state.filter, action.data);
      state.dataChanged = Date.now();
      state.nextToken = undefined;
      return state;
    case "NEXT_TOKEN":
      state.nextToken = action.data;
      return state;
    case "SET":
      state.filter = action.data;
      state.dataChanged = Date.now();
      state.nextToken = undefined;
      return state;
    case "DATA_CHANGED":
      state.dataChanged = Date.now();
      return state;
    default:
      return state;
  }
};

export interface SearchState {
  variables: QuerySearchUserResourcesArgs;
  filter: SearchFields;
  limit?: number;
  dataChanged: number;
  resultsChanged: number;
  nextToken?: string;
}

export type SearchAction =
  | {
      type: "INITIAL";
      data: QuerySearchUserResourcesArgs;
    }
  | {
      type: "UPDATE";
      data: Partial<SearchFields>;
    }
  | {
      type: "TOGGLE_SELECT";
      field: keyof ArraySearchFields;
      value: string;
    }
  | {
      type: "RESET";
    }
  | {
      type: "NEXT_TOKEN";
      data: string;
    }
  | {
      type: "SET";
      data: SearchFields;
    }
  | {
      type: "DATA_CHANGED";
    };

export type SearchFieldsAndQuery = SearchFields & {
  aggs?: SearchableResourceAggsInput[];
  filter?: {
    query: string;
  };
};
